export default {
  userNotifications: state => state.userNotifications
}
